
<template>
	<v-container fluid="fluid" class="text-xs-center pa-4">
		<v-layout row wrap>
			<history-table @showHistory="showHistory"></history-table>
		</v-layout>
		<history-modal
			:id="reservation.rentId"
			:edit="edit"
			:selectedReservation="reservation"
			:units="units"
			ref="historyModal"
			@copyReservation="copyReservation($event)"
		></history-modal>
		<new-reservation-modal
			:id="reservation.rentId"
			:edit="newReservationData"
			:units="units"
			ref="newReservationModal"
		></new-reservation-modal>
	</v-container>
</template>
<script>
import HistoryTable from '@/components/History/HistoryTable';
import HistoryModal from '@/components/History/HistoryModal';
import HistoryFilter from '@/components/History/HistoryFilter';
import NewReservationModal from '@/components/Reservations/NewReservationModal';
import * as utils from '@/utils/utils';
import moment from 'moment';

export default {
	name: 'History',
	components: {
		HistoryTable,
		HistoryModal,
		HistoryFilter,
		NewReservationModal
	},
	data() {
		return {
			reservation: {
				costData: {
					additionalItems: []
				},
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			newReservationData: {},
			units: []
		};
	},
	created() {
		window.emitter.$on('updateHistory', function() {});
	},
	mounted() {
		if (this.$route.params.id) {
			this.$refs.historyModal.getHistoryData(this.$route.params.id, false);
		}
	},
	methods: {
		showHistory(reservation) {
			// Get units for selection in history modal
			this.getUnits();

			this.$refs.historyModal.getHistoryData(
				reservation.rentId,
				reservation.showMail
			);
		},
		getUnits() {
			if (!this.units.length) {
				var self = this;
				utils
					.getData(basePath + 'api/rentunits/getSimpleUnitList')
					.then(function(response) {
						self.units = response.data;
					});
			}
		},
		copyReservation(reservation) {
			let diff = moment(reservation.endDate).diff(
				moment(reservation.startDate),
				'months'
			);
			let newEndDate = moment(reservation.endDate)
				.add(diff, 'months')
				.format('YYYY-MM-DD');

			this.$refs.newReservationModal.openModalWithData(
				reservation.endDate,
				reservation.endTime,
				newEndDate,
				reservation.endTime,
				reservation.unitId,
				reservation.user_id,
				reservation
			);
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/History/History.vue